module.exports = __webpack_public_path__ + "img/banner-bni.85d1d963.webp";